const FREQUENCIES = {
    'C0': 16.35,
    'C#0': 17.32,
    'Db0': 17.32,
    'D0': 18.35,
    'D#0': 19.45,
    'Eb0': 19.45,
    'E0': 20.60,
    'F0': 21.83,
    'F#0': 23.12,
    'Gb0': 23.12,
    'G0': 24.50,
    'G#0': 25.96,
    'Ab0': 25.96,
    'A0': 27.50,
    'A#0': 29.14,
    'Bb0': 29.14,
    'B0': 30.87,
    'C1': 32.70,
    'C#1': 34.65,
    'Db1': 34.65,
    'D1': 36.71,
    'D#1': 38.89,
    'Eb1': 38.89,
    'E1': 41.20,
    'F1': 43.65,
    'F#1': 46.25,
    'Gb1': 46.25,
    'G1': 49.00,
    'G#1': 51.91,
    'Ab1': 51.91,
    'A1': 55.00,
    'A#1': 58.27,
    'Bb1': 58.27,
    'B1': 61.74,
    'C2': 65.41,
    'C#2': 69.30,
    'Db2': 69.30,
    'D2': 73.42,
    'D#2': 77.78,
    'Eb2': 77.78,
    'E2': 82.41,
    'F2': 87.31,
    'F#2': 92.50,
    'Gb2': 92.50,
    'G2': 98.00,
    'G#2': 103.83,
    'Ab2': 103.83,
    'A2': 110.00,
    'A#2': 116.54,
    'Bb2': 116.54,
    'B2': 123.47,
    'C3': 130.81,
    'C#3': 138.59,
    'Db3': 138.59,
    'D3': 146.83,
    'D#3': 155.56,
    'Eb3': 155.56,
    'E3': 164.81,
    'F3': 174.61,
    'F#3': 185.00,
    'Gb3': 185.00,
    'G3': 196.00,
    'G#3': 207.65,
    'Ab3': 207.65,
    'A3': 220.00,
    'A#3': 233.08,
    'Bb3': 233.08,
    'B3': 246.94,
    'C4': 261.63,
    'C#4': 277.18,
    'Db4': 277.18,
    'D4': 293.66,
    'D#4': 311.13,
    'Eb4': 311.13,
    'E4': 329.63,
    'F4': 349.23,
    'F#4': 369.99,
    'Gb4': 369.99,
    'G4': 392.00,
    'G#4': 415.30,
    'Ab4': 415.30,
    'A4': 440.00,
    'A#4': 466.16,
    'Bb4': 466.16,
    'B4': 493.88,
    'C5': 523.25,
    'C#5': 554.37,
    'Db5': 554.37,
    'D5': 587.33,
    'D#5': 622.25,
    'Eb5': 622.25,
    'E5': 659.25,
    'F5': 698.46,
    'F#5': 739.99,
    'Gb5': 739.99,
    'G5': 783.99,
    'G#5': 830.61,
    'Ab5': 830.61,
    'A5': 880.00,
    'A#5': 932.33,
    'Bb5': 932.33,
    'B5': 987.77,
    'C6': 1046.50,
    'C#6': 1108.73,
    'Db6': 1108.73,
    'D6': 1174.66,
    'D#6': 1244.51,
    'Eb6': 1244.51,
    'E6': 1318.51,
    'F6': 1396.91,
    'F#6': 1479.98,
    'Gb6': 1479.98,
    'G6': 1567.98,
    'G#6': 1661.22,
    'Ab6': 1661.22,
    'A6': 1760.00,
    'A#6': 1864.66,
    'Bb6': 1864.66,
    'B6': 1975.53,
    'C7': 2093.00,
    'C#7': 2217.46,
    'Db7': 2217.46,
    'D7': 2349.32,
    'D#7': 2489.02,
    'Eb7': 2489.02,
    'E7': 2637.02,
    'F7': 2793.83,
    'F#7': 2959.96,
    'Gb7': 2959.96,
    'G7': 3135.96,
    'G#7': 3322.44,
    'Ab7': 3322.44,
    'A7': 3520.00,
    'A#7': 3729.31,
    'Bb7': 3729.31,
    'B7': 3951.07,
    'C8': 4186.01,
    'C#8': 4434.92,
    'Db8': 4434.92,
    'D8': 4698.63,
    'D#8': 4978.03,
    'Eb8': 4978.03,
    'E8': 5274.04,
    'F8': 5587.65,
    'F#8': 5919.91,
    'Gb8': 5919.91,
    'G8': 6271.93,
    'G#8': 6644.88,
    'Ab8': 6644.88,
    'A8': 7040.00,
    'A#8': 7458.62,
    'Bb8': 7458.62,
    'B8': 7902.13,
};

const noteToFreq = {
    '1': 'A2',
    '1.5': 'A#2',
    '2': 'B2',
    '3': 'C3',
    '3.5': 'C#3',
    '4': 'D3',
    '4.5': 'D#3',
    '5': 'E3',
    '6': 'F3',
    '6.5': 'F#3',
    '7': 'G3',
    '7.5': 'G#3',
    '8': 'A3',
    '8.5': 'A#3',
    '9': 'B3',
    '10': 'C4',
    '10.5': 'C#4',
    '11': 'D4',
    '11.5': 'D#4',
    '12': 'E4',
};

const keyMapping = {
    'KeyA': '1',
    'KeyW': '1.5',
    'KeyS': '2',
    'KeyD': '3',
    'KeyR': '3.5',
    'KeyF': '4',
    'KeyT': '4.5',
    'KeyG': '5',
    'KeyH': '6',
    'KeyU': '6.5',
    'KeyJ': '7',
    'KeyI': '7.5',
    'KeyK': '8',
    'KeyO': '8.5',
    'KeyL': '9',
    'Semicolon': '10',
    'BracketLeft': '10.5',
    'Quote': '11',
    'BracketRight': '11.5',
    'Backslash': '12',
    'Digit1': '1',
    'Digit2': '2',
    'Digit3': '3',
    'Digit4': '4',
    'Digit5': '5',
    'Digit6': '6',
    'Digit7': '7',
    'Digit8': '8',
    'Digit9': '9',
    'Digit0': '10',
    'Minus': '11',
    'Equal': '12',
    'Numpad1': '1',
    'Numpad2': '2',
    'Numpad3': '3',
    'Numpad4': '4',
    'Numpad5': '5',
    'Numpad6': '6',
    'Numpad7': '7',
    'Numpad8': '8',
    'Numpad9': '9',
    'Numpad0': '10',
    'NumpadDecimal': '11',
    'NumpadEnter': '12',
    'NumpadDivide': '10',
    'NumpadMultiply': '11',
    'NumpadSubtract': '12',
};

const sustainableNotes = [
    'Digit1',
    'Digit3',
    'Digit4',
    'Digit6',
    'Digit7',
    'Digit8',
    'Digit0',
    'Minus',
    'Numpad1',
    'Numpad3',
    'Numpad4',
    'Numpad6',
    'Numpad7',
    'Numpad8',
    'Numpad0',
    'NumpadDecimal',
    'NumpadDivide',
    'NumpadMultiply',
];


// SONGS:

const NOTE_SHORT = 500;
const NOTE_NORMAL = 750;
const NOTE_LONG = 1500;


function parseTabs(tabsStr) {
    return tabsStr
        .replace(/^\/\/.+$/igm, '')
        .replace(/ /ig, '')
        .split(/[\n\r|\-\,]/)
        .filter(Boolean);
}

function normalizeTabs(tabsStr) {
    return tabsStr
        .replace(/^\/\/.+$/igm, '')
        .replace(/ /ig, '')
        .replace(/[|\-\,]/ig, ', ')
        .split(/[\n\r]/)
        .filter(Boolean)
        .map(line => line.split(', ').filter(Boolean));
}


// DOM:

const HAS_TOUCH = 'ontouchstart' in window || navigator.maxTouchPoints;

const keysElement = document.querySelector('.keys');

const keys = Array.from(keysElement.children).reduce((obj, keyElement) => {
    obj[keyElement.id.replace('key-', '')] = keyElement;

    return obj;
}, {});


const TABS = {

};


// AUDIO:

window.defaultRate = 10;
window.defaultDepth = 5;

function withVibrato(audioCtx, audioParam, options = {}) {
    if (window.OscillatorNode && audioCtx instanceof OscillatorNode) {
        options = audioParam || {};
        audioParam = audioCtx.frequency;
        audioCtx = audioCtx.context;
    } else if (!audioCtx) {
        throw new Error("AudioContext not specified.");
    } else if (!audioParam) {
        throw new Error("AudioParam not specified.");
    }

    let oscillator = audioCtx.createOscillator();
    oscillator.frequency.value = options.rate || window.defaultRate;

    let gain = audioCtx.createGain();
    gain.gain.value = options.depth || window.defaultDepth;

    oscillator.connect(gain).connect(audioParam);
    oscillator.start();
}

window.AudioContext = window.AudioContext || window.webkitAudioContext;

let context = null;

try {
    if (window.AudioContext) {
        context = new window.AudioContext();
        window.audioContext = context;
    }
} catch (e) {
    console.log('No Web Audio API support');
}

let currentOscillator;
let currentFrequency = 0;
let isClicking = false;

let vibrato = false;
let mode = 2;
let type = 'square';


function playFreq(frequency) {
    if (!context) return;

    /*
     * Mobile Safari and other mobile browsers can initially
     * suspend Web Audio until a genuine user interaction.
     */
    if (context.state === 'suspended') {
        context.resume().catch(() => {});
    }

    if (currentFrequency === frequency) return;

    currentFrequency = frequency;

    const oscillator = context.createOscillator();
    const gainNode = context.createGain();

    const sweepEnv = context.createGain();

    sweepEnv.gain.setValueAtTime(0.05, context.currentTime);
    sweepEnv.gain.linearRampToValueAtTime(
        0.75,
        context.currentTime + 0.5
    );

    /*
     * Disconnect the previous oscillator if there is one.
     */
    if (currentOscillator) {
        currentOscillator.disconnect();
    }

oscillator.type = type;
oscillator.frequency.value = frequency;

let outputGain = 0.18;

if (type === 'sine') {
    outputGain = 0.28;
}

gainNode.gain.setValueAtTime(
    0.001,
    context.currentTime
);

gainNode.gain.exponentialRampToValueAtTime(
    outputGain,
    context.currentTime + 0.015
);

oscillator.connect(gainNode);
gainNode.connect(context.destination);

    currentOscillator = oscillator;

    if (vibrato) {
        withVibrato(oscillator);
    }

    oscillator.start(0);
}


let activeKey = null;

function stopFreq() {
    if (!currentOscillator) return;

    currentFrequency = 0;

    try {
        currentOscillator.stop(0);
        currentOscillator.disconnect();
    } catch (error) {
        // Oscillator may already have been stopped.
    }

    currentOscillator = null;

    if (activeKey) {
        activeKey.classList.remove('isActive');
    }

    activeKey = null;
}


function handleNote(note, sustained) {
    note = sustained
        ? `${parseInt(note, 10) + 0.5}`
        : note;

    checkNote(note);

    if (activeKey) {
        activeKey.classList.remove('isActive');
    }

    activeKey = keys[note] || null;

    if (activeKey) {
        activeKey.classList.add('isActive');
    }

    const noteName = noteToFreq[note];

    if (!noteName || !FREQUENCIES[noteName]) return;

    playFreq(FREQUENCIES[noteName]);
}


// CONTROLS:

function toggleVibrato() {
    vibrato = !vibrato;

    const button = document.getElementById('vibrato');

    if (!button) return;

    if (vibrato) {
        button.setAttribute('aria-pressed', 'true');
    } else {
        button.removeAttribute('aria-pressed');
    }
}


function setMode(nextMode) {
    const previousModeButton =
        document.getElementById(`mode-${mode}`);

    if (previousModeButton) {
        previousModeButton.removeAttribute('aria-pressed');
    }

    mode = nextMode;

    let noteIndex = 0;
    let noteCursor = `A${mode}`;
    let styloNoteCursor = 0;

    const allNotes = Object.keys(FREQUENCIES).filter(
        note => note.length === 2 || note[1] === '#'
    );

    const styloNotes = Object.keys(noteToFreq)
        .map(parseFloat)
        .sort((a, b) => a - b);

    while (
        noteCursor &&
        styloNoteCursor <= styloNotes.length - 1 &&
        noteIndex <= allNotes.length - 1
    ) {
        const note = allNotes[noteIndex++];

        if (noteCursor === note) {
            const styloNote = styloNotes[styloNoteCursor++];

            if (styloNote) {
                noteToFreq[styloNote] = noteCursor;

                const key =
                    document.getElementById(`key-${styloNote}`);

                if (key && key.children[1]) {
                    key.children[1].textContent = noteCursor;
                }
            }

            const nextNote = allNotes[noteIndex];

            noteCursor = nextNote || '';
        }
    }

    const modeButton =
        document.getElementById(`mode-${mode}`);

    if (modeButton) {
        modeButton.setAttribute('aria-pressed', 'true');
    }
}


function setType(nextType) {
    const previousTypeButton =
        document.getElementById(`type-${type}`);

    if (previousTypeButton) {
        previousTypeButton.removeAttribute('aria-pressed');
    }

    type = [
        'sawtooth',
        'square',
        'sine',
        'triangle'
    ].includes(nextType)
        ? nextType
        : 'sawtooth';

    const typeButton =
        document.getElementById(`type-${type}`);

    if (typeButton) {
        typeButton.setAttribute('aria-pressed', 'true');
    }
}


// MOUSE:

function handleMouseDown(e) {
    if (!e.target) return;

    isClicking = true;

    const target = e.target.closest
        ? e.target.closest('.key, #vibrato, [id^="mode-"], [id^="type-"]')
        : e.target;

    if (!target) return;

    const { id, classList } = target;

    if (classList.contains('key')) {
        handleNote(id.replace('key-', ''));
    } else if (id === 'vibrato') {
        toggleVibrato();
    } else if (id.startsWith('mode-')) {
        setMode(
            parseInt(id.replace('mode-', ''), 10) || 2
        );
    } else if (id.startsWith('type-')) {
        setType(id.replace('type-', ''));
    }
}


function handleMouseUp() {
    isClicking = false;
    stopFreq();
}


function handleMouseOver(e) {
    if (!e.target) return;

    const target = e.target.closest
        ? e.target.closest('.key')
        : e.target;

    if (!target || !target.classList.contains('key')) {
        if (isClicking) {
            stopFreq();
        }

        return;
    }

    if (isClicking) {
        handleNote(
            target.id.replace('key-', '')
        );
    }
}


/*
 * Mouse listeners are temporarily disabled during touch
 * interaction. Mobile browsers can generate synthetic mouse
 * events after a touch, which was causing controls to toggle
 * twice.
 */

let mouseEventListenersInitialized = false;

function addMouseEventListeners() {
    if (mouseEventListenersInitialized) return;

    mouseEventListenersInitialized = true;

    document.addEventListener(
        'mousedown',
        handleMouseDown
    );

    document.addEventListener(
        'mouseup',
        handleMouseUp
    );

    document.addEventListener(
        'mouseover',
        handleMouseOver
    );
}


function removeMouseEventListeners() {
    if (!mouseEventListenersInitialized) return;

    mouseEventListenersInitialized = false;

    document.removeEventListener(
        'mousedown',
        handleMouseDown
    );

    document.removeEventListener(
        'mouseup',
        handleMouseUp
    );

    document.removeEventListener(
        'mouseover',
        handleMouseOver
    );
}


addMouseEventListeners();


// TOUCH:

let lastTouched = null;

function handleTouchStart(e) {
    const touch = e.touches && e.touches[0];

    if (!touch) return;

    lastTouched = touch.target || null;

    /*
     * Prevent the synthetic mouse event following a touch
     * from activating a controller for a second time.
     */
    removeMouseEventListeners();

    /*
     * Resume Web Audio directly from the user gesture.
     */
    if (
        context &&
        context.state === 'suspended'
    ) {
        context.resume().catch(() => {});
    }

    handleMouseDown({
        target: touch.target
    });
}


function handleTouchEnd() {
    lastTouched = null;

    handleMouseUp();

    /*
     * Some mobile browsers dispatch synthetic mouse events
     * shortly after touchend, so don't restore the mouse
     * listeners immediately.
     */
    window.setTimeout(
        addMouseEventListeners,
        400
    );
}


function handleTouchMove(e) {
    const touch = e.touches && e.touches[0];

    if (!touch || !keysElement) return;

    const target = document.elementFromPoint(
        touch.clientX,
        touch.clientY
    );

    if (
        !target ||
        target === lastTouched
    ) {
        return;
    }

    const key = target.closest
        ? target.closest('.key')
        : target;

    /*
     * Only allow finger-drag playing inside the keyboard.
     * Moving across the controller panel should not
     * accidentally operate controls.
     */
    if (
        !key ||
        !keysElement.contains(key)
    ) {
        return;
    }

    lastTouched = key;

    handleMouseOver({
        target: key
    });
}


if (HAS_TOUCH) {
    const stylophoneElement =
        document.querySelector('.stylophone');

    if (stylophoneElement) {
        stylophoneElement.addEventListener(
            'touchstart',
            handleTouchStart,
            { passive: true }
        );

        stylophoneElement.addEventListener(
            'touchend',
            handleTouchEnd,
            { passive: true }
        );

        stylophoneElement.addEventListener(
            'touchcancel',
            handleTouchEnd,
            { passive: true }
        );

        stylophoneElement.addEventListener(
            'touchmove',
            handleTouchMove,
            { passive: true }
        );
    }
}


// KEYBOARD:

/*
 * Stylophone keyboard shortcuts must never take over while
 * somebody is using a normal storefront control.
 */

function isInteractiveKeyboardTarget(target) {
    if (!(target instanceof Element)) {
        return false;
    }

    return Boolean(
        target.closest(
            [
                'input',
                'textarea',
                'select',
                'option',
                'button',
                'a[href]',
                '[contenteditable="true"]',
                '[contenteditable=""]',
                '[role="textbox"]',
                '[role="combobox"]',
                '[role="searchbox"]'
            ].join(',')
        )
    );
}


const pressedKeys = [];
const pressedKeysMap = {};


document.addEventListener('keydown', (e) => {
    if (
        isInteractiveKeyboardTarget(e.target) ||
        e.ctrlKey ||
        e.metaKey ||
        e.altKey
    ) {
        return;
    }

    const { code: c } = e;

    /*
     * Only prevent normal browser behaviour for keyboard
     * commands which the Stylophone actually consumes.
     */
    if (c === 'ArrowLeft') {
        e.preventDefault();
        handleRewind();
        return;
    }

    if (c === 'ArrowRight') {
        e.preventDefault();
        handleForward();
        return;
    }

    if (
        c === 'NumpadAdd' ||
        c === 'Space'
    ) {
        e.preventDefault();
        pressedKeysMap.plus = true;
    } else if (keyMapping[c]) {
        e.preventDefault();

        if (pressedKeysMap[c]) return;

        pressedKeys.push(c);
        pressedKeysMap[c] = true;
    } else {
        /*
         * Not a Stylophone keyboard command.
         */
        return;
    }

    const code =
        pressedKeys[pressedKeys.length - 1];

    const note = keyMapping[code];

    if (!note) return;

    handleNote(
        note,
        pressedKeysMap.plus &&
        sustainableNotes.includes(code)
    );
});


document.addEventListener('keyup', (e) => {
    if (
        isInteractiveKeyboardTarget(e.target) ||
        e.ctrlKey ||
        e.metaKey ||
        e.altKey
    ) {
        return;
    }

    const { code: c } = e;

    if (
        c === 'ArrowLeft' ||
        c === 'ArrowRight'
    ) {
        return;
    }

    /*
     * IMPORTANT:
     *
     * The old script called e.preventDefault() for EVERY
     * keyup event on the entire storefront.
     *
     * We deliberately do not do that here.
     */

    if (
        c === 'NumpadAdd' ||
        c === 'Space'
    ) {
        delete pressedKeysMap.plus;
    } else if (keyMapping[c]) {
        const index =
            pressedKeys.indexOf(c);

        if (index > -1) {
            pressedKeys.splice(index, 1);
        }

        delete pressedKeysMap[c];

        if (pressedKeys.length === 0) {
            stopFreq();
            return;
        }
    } else {
        return;
    }

    const code =
        pressedKeys[pressedKeys.length - 1];

    const note = keyMapping[code];

    if (!note) return;

    handleNote(
        note,
        pressedKeysMap.plus &&
        sustainableNotes.includes(code)
    );
});


// MARK:

let allNotesElements = [];
let currentNoteElement = null;
let currentNote = 0;
let currentTab = [];
let intervalID = null;

const tab = document.getElementById('tab');
const tabs = document.getElementById('tabs');
const tabsLines = document.getElementById('tabsLines');
const markNext = document.getElementById('markNext');
const markNextNext = document.getElementById('markNextNext');


function moveMark(nextKey, nextNextKey) {
    if (!markNext || !markNextNext) return;

    if (nextKey) {
        markNext.style.left =
            `${nextKey.offsetLeft}px`;

        markNext.style.width =
            `${nextKey.offsetWidth}px`;

        markNext.style.height =
            nextKey.classList.contains('black')
                ? '50%'
                : '100%';

        markNext.removeAttribute('hidden');
    } else {
        markNext.setAttribute(
            'hidden',
            'true'
        );
    }

    if (nextNextKey) {
        markNextNext.style.left =
            `${nextNextKey.offsetLeft}px`;

        markNextNext.style.width =
            `${nextNextKey.offsetWidth}px`;

        markNextNext.style.height =
            nextNextKey.classList.contains('black')
                ? '50%'
                : '100%';

        markNextNext.removeAttribute('hidden');
    } else {
        markNextNext.setAttribute(
            'hidden',
            'true'
        );
    }

    if (currentNoteElement) {
        currentNoteElement.classList.remove(
            'isCurrent'
        );
    }

    currentNoteElement =
        allNotesElements[currentNote];

    if (currentNoteElement) {
        currentNoteElement.classList.add(
            'isCurrent'
        );

        if (tabsLines) {
            const scrollBy =
                tabsLines.getBoundingClientRect().top -
                currentNoteElement.getBoundingClientRect().top +
                8;

            if (scrollBy) {
                tabsLines.scrollBy(
                    0,
                    -scrollBy
                );
            }
        }
    }
}


function playNote() {
    const note =
        currentTab[currentNote++];

    if (!note) {
        handleMouseUp();
        return;
    }

    const key =
        document.getElementById(
            `key-${note}`
        );

    if (!key) {
        handleMouseUp();
        return;
    }

    moveMark(key);

    handleMouseDown({
        target: key
    });

    setTimeout(
        handleMouseUp,
        NOTE_NORMAL - 50
    );

    intervalID = setTimeout(
        playNote,
        NOTE_NORMAL
    );
}


function checkNote(note) {
    if (
        currentTab[currentNote] === note
    ) {
        const nextKey =
            currentTab[++currentNote];

        if (nextKey) {
            moveMark(
                document.getElementById(
                    `key-${nextKey}`
                ),
                document.getElementById(
                    `key-${currentTab[currentNote + 1]}`
                )
            );
        } else if (
            currentNote === currentTab.length
        ) {
            currentNote =
                currentTab.length - 1;
        }
    }
}


function handleReset() {
    currentNote = 0;

    moveMark(
        document.getElementById(
            `key-${currentTab[currentNote]}`
        ),
        document.getElementById(
            `key-${currentTab[currentNote + 1]}`
        )
    );

    clearInterval(intervalID);
}


function handleReRender() {
    moveMark(
        document.getElementById(
            `key-${currentTab[currentNote]}`
        ),
        document.getElementById(
            `key-${currentTab[currentNote + 1]}`
        )
    );
}


function handleStart() {
    if (currentNote === 0) return;

    currentNote = 0;

    moveMark(
        document.getElementById(
            `key-${currentTab[currentNote]}`
        ),
        document.getElementById(
            `key-${currentTab[currentNote + 1]}`
        )
    );
}


function handleRewind() {
    if (currentNote <= 0) return;

    --currentNote;

    moveMark(
        document.getElementById(
            `key-${currentTab[currentNote]}`
        ),
        document.getElementById(
            `key-${currentTab[currentNote - 1]}`
        )
    );
}


function handleForward() {
    if (
        currentNote >=
        currentTab.length - 1
    ) {
        return;
    }

    ++currentNote;

    moveMark(
        document.getElementById(
            `key-${currentTab[currentNote]}`
        ),
        document.getElementById(
            `key-${currentTab[currentNote + 1]}`
        )
    );
}


function handleEnd() {
    if (
        currentNote ===
        currentTab.length - 1
    ) {
        return;
    }

    currentNote =
        currentTab.length - 1;

    moveMark(
        document.getElementById(
            `key-${currentTab[currentNote]}`
        ),
        null
    );
}


function handleSeek(tabNoteElement) {
    const index =
        allNotesElements.indexOf(
            tabNoteElement
        );

    if (index === -1) return;

    currentNote = index;

    moveMark(
        document.getElementById(
            `key-${currentTab[currentNote]}`
        ),
        document.getElementById(
            `key-${currentTab[currentNote + 1]}`
        )
    );
}


const buttonStart =
    document.querySelector('#start');

const buttonRewind =
    document.querySelector('#rewind');

const buttonForward =
    document.querySelector('#forward');

const buttonEnd =
    document.querySelector('#end');


function selectTab(tabID) {
    const tabObject = TABS[tabID];

    if (!tabObject) {
        clearTab();
        return;
    }

    currentTab = tabObject.parsed;

    if (!currentTab) {
        clearTab();
        return;
    }

    if (
        !location.hash.endsWith(tabID)
    ) {
        history.replaceState(
            null,
            null,
            `#${tabID}`
        );
    }

    if (
        tab &&
        tab.value !== tabID
    ) {
        tab.value = tabID;
    }

    if (buttonStart) {
        buttonStart.disabled = false;
    }

    if (buttonRewind) {
        buttonRewind.disabled = false;
    }

    if (buttonForward) {
        buttonForward.disabled = false;
    }

    if (buttonEnd) {
        buttonEnd.disabled = false;
    }

    if (!tabsLines || !tabs) return;

    tabsLines.innerHTML = `
        ${TABS[tabID].raw.map((line) => {
            const notesElements =
                line.map((note) => {
                    return `<li class="tabs__note">${note}</li>`;
                }).join('');

            return `<li class="tabs__line"><ol class="tabs__notes">${notesElements}</ol></li>`;
        }).join('')}
    `;

    allNotesElements =
        Array.from(
            tabs.querySelectorAll(
                '.tabs__note'
            )
        );

    handleReset();
}


function clearTab() {
    currentTab = [];
    currentNote = 0;

    history.replaceState(
        null,
        null,
        ' '
    );

    if (buttonStart) {
        buttonStart.disabled = true;
    }

    if (buttonRewind) {
        buttonRewind.disabled = true;
    }

    if (buttonForward) {
        buttonForward.disabled = true;
    }

    if (buttonEnd) {
        buttonEnd.disabled = true;
    }

    if (markNext) {
        markNext.setAttribute(
            'hidden',
            'true'
        );
    }

    if (markNextNext) {
        markNextNext.setAttribute(
            'hidden',
            'true'
        );
    }

    if (tabsLines) {
        tabsLines.innerHTML = '';
    }
}


function handleTabChange({ target }) {
    const tabID = target.value;

    if (tabID) {
        selectTab(tabID);
    } else {
        clearTab();
    }
}


if (
    markNext &&
    markNextNext &&
    buttonStart &&
    buttonRewind &&
    buttonForward &&
    buttonEnd &&
    tabs &&
    tab
) {
    buttonStart.addEventListener(
        'click',
        handleStart
    );

    buttonRewind.addEventListener(
        'click',
        handleRewind
    );

    buttonForward.addEventListener(
        'click',
        handleForward
    );

    buttonEnd.addEventListener(
        'click',
        handleEnd
    );

    tabs.addEventListener(
        'click',
        ({ target }) => {
            if (
                !target.classList.contains(
                    'tabs__note'
                )
            ) {
                return;
            }

            handleSeek(target);
        }
    );

    tab.addEventListener(
        'change',
        handleTabChange
    );

    if (location.hash) {
        selectTab(
            location.hash.slice(1)
        );
    }
}


/*
 * Desktop hover styling.
 */

if (
    !('ontouchstart' in window) &&
    !navigator.maxTouchPoints
) {
    document.body.classList.add(
        'hasHover'
    );
}


/*
 * Reposition tab markers after resizing.
 */

let rafID = null;

window.addEventListener(
    'resize',
    () => {
        cancelAnimationFrame(rafID);

        rafID = requestAnimationFrame(
            () => {
                handleReRender();
            }
        );
    }
);


/*
 * CONTEXT MENU
 *
 * The original script installed a contextmenu listener on
 * window, which affected the entire Shopify storefront.
 *
 * We only suppress the context menu directly over a
 * Stylophone key. Normal right-click behaviour elsewhere
 * on the site is untouched.
 */

if (keysElement) {
    keysElement.addEventListener(
        'contextmenu',
        (e) => {
            const key =
                e.target.closest
                    ? e.target.closest('.key')
                    : null;

            if (
                key &&
                keysElement.contains(key)
            ) {
                e.preventDefault();
            }
        }
    );
}